module.exports = __webpack_public_path__ + "img/mac.9b075bd0.png";